import shouldUpdate from "./shouldUpdate";
import shallowEqual from "./utils/shallowEqual";
export var pure = shouldUpdate(function (prev, next) { return !shallowEqual(prev, next); });
export default pure;

//# sourceMappingURL=pure.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/pure.js
// module id = 217
// module chunks = 0